import React from "react";
import { useIntl } from "react-intl";

import CookieConsent from "react-cookie-consent";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './CookieConsent.scss';

import LogService from "../../middleware/CommonSdk/LogService";
const LOG_TAG = "COOKIE_CONSENT";

const ReactCookieConsent = () => {
    const intl = useIntl();

    return (
        <CookieConsent
            id="CookieConsent"
            disableStyles={true}
            location="top"
            buttonText="Continue"
            buttonClasses="btn btn-purple"
            containerClasses="banner bg-green text-white col-lg-12"
            contentClasses="p-2"
            onAccept={() => {
                LogService.info(LOG_TAG, "Accept Cookie...");
            }}
        >
            <h5>{intl.messages.cookieConsentTitle}</h5>
            <div>{intl.messages.cookieConsentMessage}</div>
            <div>
                <a target="_blank" className="btn-link-purple" rel="noopener noreferrer" href="https://www.al-enterprise.com/en/legal/cookie-policy">
                    <FontAwesomeIcon icon={faArrowRight} className="mr-2"/>
                    <span>{intl.messages.cookieConsentLearnMore}</span>
                </a>
            </div>
        </CookieConsent>
    );
};

export default ReactCookieConsent;


